import { getModule } from "vuex-module-decorators";
import { Route, NavigationGuardNext } from "vue-router";
import { MediaModule } from "@/modules/media";
import { MediaUploadModule } from "@/modules/media-upload";
import CategoryManagerState from "@/modules/category-manager";
import TitleListState from "@/modules/title-list";
import { Paths } from "@/util/paths";

export const MediaResolver = async (to: Route, from: Route, next: NavigationGuardNext) => {
	let componentId = to.params.id;
	const actions: Promise<void>[] = [];
	actions.push(MediaUploadModule.getSasURL());

	const titleListModule = getModule(TitleListState);
	const categoryModule = getModule(CategoryManagerState);

	if (!componentId) {
		next(Paths.NotFound);
		return;
	}
	if (
		titleListModule.editeContentSelectedChapterId !== "none" &&
		titleListModule.editeContentSelectedChapterId !== "all"
	) {
		componentId = titleListModule.editeContentSelectedChapterId;
	}
	if (componentId && !titleListModule.editedContentId.length) {
		actions.push(titleListModule.fetchContentDetails(componentId));
	}

	if (!titleListModule.languageSkills.length) {
		actions.push(titleListModule.fetchLanguageSkills());
	}
	if (!titleListModule.levels.length) {
		actions.push(titleListModule.fetchVcsLevels());
	}
	if (!titleListModule.tags.length) {
		actions.push(titleListModule.fetchVcsTags());
	}
	if (!categoryModule.categories.length) {
		actions.push(categoryModule.fetchCategories());
	}

	await Promise.all(actions);
	next();
};
